import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/app.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration.js";

const root = ReactDOM.createRoot(document.getElementById("page"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
